export default __webpack_public_path__ + "static/media/lock.e5f42f57.svg";